//  global variables

var globals = (function() {

	// [ centre_name, region, centre_email_address]
	var $educare_centres = [
	    ["Adventure", "Wellington", "adventure@educare.co.nz"],
	    ["Albert Street", "Pukekohe", "albertstreet@educare.co.nz"],
	    ["Bream Bay", "Northland", "breambay@educare.co.nz"],
	    ["Hikurangi", "Northland", "hikurangi@educare.co.nz"],
	    ["Kāpiti", "Wellington", "kapiti@educare.co.nz"],
	    ["Kensington Park", "Northland", "kensingtonpark@educare.co.nz"],
	    ["Kitchener Rd", "Auckland", "kitchenerrd@educare.co.nz"],
	    ["Norfolk", "Northland", "norfolk@educare.co.nz"],
	    ["Okara", "Northland", "okara@educare.co.nz"],
	    ["One Tree Point", "Northland", "onetreepoint@educare.co.nz"],
	    ["Orewa", "Auckland", "orewa@educare.co.nz"],
	    ["Pokeno", "Auckland", "pokeno@educare.co.nz"],   
	    ["Taupiri", "Waikato", "taupiri@educare.co.nz"],
	    ["Tawa", "Wellington", "tawa@educare.co.nz"],
	    ["Tikipunga", "Northland", "tikipunga@educare.co.nz"],
	    ["Totara Park", "Northland", "totarapark@educare.co.nz"],
	    ["Warkworth", "Northland", "warkworth@educare.co.nz"],
	    ["Waimak", "Canterbury", "waimak@educare.co.nz"] ,
	    ["Wigram", "Canterbury", "wigram@educare.co.nz"]                   
	];

	// 
	function get_centre_id_by_name(centre_name)
	{
		for (var i=0; i < $educare_centres.length; i++) {

			if($educare_centres[i][0] === centre_name){
				return i;
			}
		}
	}

	var get_region_for_centre = function get_region_for_centre(centre_name){

		var centre_id = $educare_centres.indexOf(centre_name);

		var region = $educare_centres[centre_id][1];

		return region;

	};

	var get_all_regions = function get_all_regions(){

		$regions = $educare_centres[0];

		return array_unique($regions);

	};

	var get_email_address_for_centre = function get_email_address_for_centre(centre_name){

		var centre_id = $educare_centres.indexOf(centre_name);

		var centre_email = $educare_centres[centre_id][2];

		return centre_email;
	};

	var get_centres_for_region = function get_centres_for_region(region){

		var centres = [];

		for (var i=0; i < $educare_centres.length; i++) {

			if($educare_centres[i][1] === region){
				centres.push($educare_centres[i][0]);
			}
		}

		return centres;
	};


	// PUBLIC MEMBERS
	var result = {
		get_email_address_for_centre: get_email_address_for_centre,
		get_region_for_centre: get_region_for_centre,
		get_centres_for_region: get_centres_for_region
	};

	return result;

}) ();
